<template>
  <div
    class="flex flex-col bg-white empty-state-wrapper p-10"
    :class="{ 'w-full mx-4 md:w-1/2': responsive, 'empty-wrapper-width': !responsive }"
  >
    <div
      class="m-auto text-center"
      :class="{ 'empty-state-heading': !responsive }"
    >
      <p
        class="text-2xl text-grey-900 font-bold mb-4"
        v-if="empty_state_heading"
      >
        {{ this.$t(empty_state_heading) }}
      </p>
      <p class="text-sm text-grey-700 mb-4" v-if="empty_state_sub_heading">
        {{ this.$t(empty_state_sub_heading) }}
      </p>
    </div>
    <div class="flex w-full justify-center" v-if="empty_state_button_text">
      <gd-button
        primary
        class="w-auto h-10 px-6 empty-state-add-btn"
        @click="executeCreateAction"
        >{{ this.$t(empty_state_button_text) }}</gd-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    responsive: {
      required: false,
    },
    has_video: {
      required: false,
    },
    empty_state_image: {
      required: false,
    },
    empty_state_heading: {
      required: false,
    },
    empty_state_sub_heading: {
      required: false,
    },
    empty_state_button_text: {
      required: false,
    },
    empty_state_image_width: {
      required: false,
    }
  },

  methods: {
    executeCreateAction() {
      this.$emit('executeDataCreation');
    },

    playVideo() {
      this.$emit('playVideoTutorial');
    },
  },
};
</script>

<style lang="scss">
.empty-wrapper-width {
  width: 620px;
}

.empty-state-wrapper {
  box-shadow: 20px 20px 40px rgba(22, 29, 37, 0.05);
  border-radius: 6px;
}

.empty-state-heading {
  width: 400px;
}

.empty-state-add-btn {
  font-weight: 600 !important;
  border-radius: 6px !important;
}
</style>